import { buttoBaseStyle } from '@screens/lp-default/styles';
import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.elsie.colors.inverse.surface.faint.default};
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  display: flex;
  gap: 88px;
  justify-content: space-between;
  padding: 80px 64px;
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 384px;
`;

export const IntroTitle = styled.h2`
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.accent};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  font-size: ${({ theme }) => theme.elsie.fontSize['2xl']};
  letter-spacing: 0.32px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.sm};
  margin: 0 0 20px 0;
  vertical-align: middle;
`;

export const IntroSubTitle = styled.h4`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.accent};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  font-size: ${({ theme }) => theme.elsie.fontSize.md};
  letter-spacing: 0.32px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0 0 12px 0;
  vertical-align: middle;
`;

export const IntroDescription = styled.p`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.subtle};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  font-size: ${({ theme }) => theme.elsie.fontSize.sm};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0 0 12px 0;
  vertical-align: middle;
`;

export const TabWrapper = styled.div`
  border: 1px solid purple;
  display: flex;
  flex-direction: column;
`;

export const IntroButton = styled.button`
  ${buttoBaseStyle};
  display: flex;
  flex-direction: row;
  align-items: center;
  border: ${({ theme }) => theme.elsie.borderWidth.sm} solid ${({ theme }) => theme.elsie.colors.inverse.border.subtle};
  background-color: ${({ theme }) => theme.elsie.colors.inverse.surface.faint.default};
  color: ${({ theme }) => theme.elsie.colors.inverse.content.onInteractive.soft};
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  padding: 9px 16px;
  font-size: ${({ theme }) => theme.elsie.fontSize.sm};
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  width: max-content;

  &:hover {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.surface.faint.hovered};
  }
`;
